import "react-datepicker/dist/react-datepicker.css";

import * as React from "react";
import "./Panel.scss";

export interface PanelProps {
    header?: string;
    children: any;
}

export const Panel = (props: PanelProps) => {
    return (
        <div className={"panel-wrapper"}>
            {props.header && <h3 className={"panel-header"}>{props.header}</h3>}

            <div className="panel-body">{props.children}</div>
        </div>
    );
};
